import React from "react";
import { roomsData } from "./Components/RoomsData";
import dollar_icon from "../../../assets/images/dollar-icon.png"
import no_smoking_icon from "../../../assets/images/no-smoking-icon.png"
import cleaning_icon from "../../../assets/images/cleaning-icon.png"

const filterBtn = [
    {
        id: 1,
        title: "All",
        count: "9"
    },
    {
        id: 2,
        title: "Vacant",
        count: "3"
    },
    {
        id: 3,
        title: "Occupied",
        count: "4"
    },
    {
        id: 4,
        title: "Reserved",
        count: "2"
    },
    {
        id: 5,
        title: "Booked",
        count: "0"
    },
    {
        id: 6,
        title: "Due Out",
        count: "1"
    },
    {
        id: 7,
        title: "Dirty",
        count: "9"
    }
]

const RoomView = () => {
    return (
        <div className="px-xl-5 px-lg-4 px-3 py-3 page-body ">
            <div className="row mb-3">
                <div className="col-sm-12">
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                        <h3 className="fw-bold mb-0">Room View</h3>
                    </div>
                </div>
            </div>

            <div>

                <div className="mb-4 d-flex align-items-center flex-wrap">
                    <input type="date" value="2025-10-06" className="date-container me-2 mb-2 mb-lg-0" />
                    <div className="d-flex align-items-center flex-wrap gap-2">
                        {filterBtn.map((data) => {
                            return (
                                <button key={data.id} type="button" className="room-cards-filter-btn">
                                    {data.title} <span className="room-cards-filter-count ms-1">{data.count}</span>
                                </button>
                            )
                        })}
                    </div>
                </div>

                <ul className="row g-2 list-unstyled li_animate row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-1 row-deck mb-lg-5 mb-4">
                    {roomsData.map((data, index) => {
                        return (
                            <li className="col" key={index}>
                                <div className="card room-cards p-3 h-100">
                                    <div className="room-card-body">
                                        <div>
                                            <div className="room-card-sub1">
                                                <img src={data.icon} alt="" />
                                                <div>
                                                    <span className="room-card-id">{data.room_id}</span><br />
                                                    <span className="room-card-type">{data.room_type}</span>
                                                </div>
                                            </div>
                                            <h6 className="room-card-gname mt-2">{data.guest_name}</h6>
                                        </div>
                                        <div className="room-card-sub2">
                                            <img src={dollar_icon} alt="dollar_icon" />
                                            <img src={no_smoking_icon} alt="no_smoking_icon" />
                                            <img src={cleaning_icon} alt="cleaning_icon" />
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-end mt-4">
                                        <span className="room-cards-pill rounded-pill">{data.add_ons}</span>
                                    </div>
                                </div>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </div>
    )
}

export default RoomView